export default __webpack_public_path__ + "static/visualization_placeholder-6d5bc9f0632ce18ee3fdcd9941783c14.png";